// @flow

import type { PendingIncomingPayment } from './types';

export function getSafePixQRCode(incomingPayment: PendingIncomingPayment): string {
  const pixQRCode = incomingPayment['pix']['qr_code_value'];
  if(!pixQRCode){
    throw new Error('Pix: no QR Code in incoming payment');
  }
  return pixQRCode;
}
